module.exports = __webpack_public_path__ + "static/media/ultra_cosmic grey.4aa6be32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/samsung-galaxy/ultra/ultra_cosmic grey.png
// module id = 2152
// module chunks = 0